/**
 * Идентификатор сущности бэкенда — ObjectId Mongo, 24 hex-символа. Адрес с
 * чем-то другим (`/brands/abc`) бэкенд отбивает `400`, поэтому такой адрес
 * сразу считается «не найдено» — без запроса.
 */
export const isObjectId = (value: string | undefined): value is string => !!value && /^[0-9a-f]{24}$/i.test(value)
